<template>
    
    <div>

        <section class="tracking-sec bg-full" style="background-image: url('static/images/koel_frys.jpg');">
				<div class="container">
					<div class="row">
						<div class="col-xs-12 col-sm-7 col-md-8">
						</div>
						<div class="col-xs-12 col-sm-5 col-md-4">
							<div class="track-holder bg-full" style="background-image: url('static/images/img03.jpg');">
								<div v-if="!contactSuccess" action="#" class="track-form">
									<fieldset>
										<label for="text">Skal vi ringe dig op?</label>
										<input style="color:#000;font-style:normal;" v-model="phonenumber" type="text" class="form-control md-round" placeholder="Indtast dit telefonnummer">
										<p>Vi bestræber os på at kontakte dig inden for 2 arbejdsdage.</p>
										<button @click="callMe" class="call-button btn-primary text-center text-uppercase md-round">
											RING MIG OP
											&nbsp;&nbsp;<i class="fas fa-chevron-right" />
										</button>
									</fieldset>
								</div>
								<div v-else>
									<b>Tak!</b><br>
									Vi kontakter dig snarest.
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

    </div>

</template>

<style lang="scss" scoped>
.call-button {
	
	&:hover {
		border-color: #fff;
	}
}
</style>

<script>
export default {
	data () {
		return {
			phonenumber: '',
			contactSuccess: false
		}
	},
	methods: {
		callMe () {
			this.contactSuccess = true
			var templateParams = {
				'phonenumber': this.phonenumber
			}
			window.emailjs.send('sendgrid', 'template_lwwNmNI8', templateParams)
			.then((response) => {
				console.log('SUCCESS!', response.status, response.text)
				this.contactSuccess = true
				this.$router.push({name: 'ContactSuccess'})
			}, function (error) {
				console.log('FAILED...', error)
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// promo.vue?b47c784e